export default __webpack_public_path__ + "a2468ebc31ef6d25f464c7e44c85f196.png";